import React, { Component, Fragment } from 'react'
import { Row, Col, Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from 'reactstrap';
import '../App.css';
import LoggedContext from '../BusinessObjects/LoggedContext'
import EsaedroLookupItem from '../Models/EsaedroLookupItem';
import cubeApiClient from '../BusinessObjects/cubeApiService';
import ResourcesLookups from '../Models/ResourcesLookups';
import { themeCol9, themeSpinner, themeGroup, themeCol4, themeCol3, themeFormInput } from '../Utils/EsaedroTheme';
import EsaedroResourceFilter from '../Models/EsaedroResourceFilter';


interface IEsaedroLookupsProps {
  name:string;
  value:any;
  fatherObj:any;
  lookupName: string;
  lookupValues:string;
  className?:string;
  displayName?:string;
  onChange?(event: any): void;
  onFieldsToCheckLoaded?(lookupName: string, fieldsToCheck: any[]) : void;
  items?:EsaedroLookupItem[];
  isSys?:boolean;
  isDisabled?:boolean;
}
interface IEsaedroLookupState
{
  lookupResource?: ResourcesLookups;
  items:EsaedroLookupItem[];
  itemsToDisplay:EsaedroLookupItem[];
  toggleSearch: boolean
  loading:boolean;
  lookupResourceDisplayFilters: EsaedroResourceFilter[];
  errorMessage:string;
}

export default class EsaedroLookup extends Component<IEsaedroLookupsProps, IEsaedroLookupState> {
  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  
  // Campi che manipolano il rendering
  filterFailed: boolean = false
  fieldsToCheck: any[] = []
  initialDisplayField: string = ''
  
  constructor(props: IEsaedroLookupsProps){
      super(props);
      this.state={lookupResource: undefined, items:[],itemsToDisplay:[],toggleSearch:false, loading:true, lookupResourceDisplayFilters:[], errorMessage:''};
  }

  componentDidMount()
  {
    this.getLookupData()
  }
  
  getLookupData = () => {

    // Questo metodo viene chiamato solo alla DidMount, e popola la lookup
    this.setState({loading: true})

    //Elenco di valori fissi, li setto e mi fermo
    if (this.props.lookupValues)
    {
      let valuesToShow = this.props.lookupValues.split('|')

      let newItems: EsaedroLookupItem[] = []
      let newItemsToDisp: EsaedroLookupItem[] = []
      valuesToShow.map(element => {
        var v =element.split('=');
        newItems.push(new EsaedroLookupItem(v[0],v[1]));
        newItemsToDisp.push(new EsaedroLookupItem(v[0],v[1]));
      });

      this.setState({
        items: newItems,
        itemsToDisplay: newItemsToDisp,
        loading:false
      });
    }
    else
      //Elenco da lookup resource - Gestione complessa
      if(this.props.lookupName)
      {
        //Col lookupName vado a richiedere i dettagli della lookup
        const service = new cubeApiClient();
        const t = this.context.tokenAPI;
        var requrl ="api/sys/ResourcesLookups?RecordSelection=" + encodeURIComponent("LookupName='" + this.props.lookupName + "'")   ; 
          
        service
            .getItems(requrl,t)
            .then((data: any) => {
                //Se li trovo procedo
                if (data)
                {
                  var resourceLookup:ResourcesLookups=data[0];
                  if (resourceLookup)
                  {
                    // Compilo i fieldsToCheck 
                    if (resourceLookup.ResourcesLookupsFilters) {
                      for(var i=0;i< resourceLookup.ResourcesLookupsFilters.length;i++)
                      {
                          this.fieldsToCheck.push(resourceLookup.ResourcesLookupsFilters[i].ParentField_Name)
                      }
                      // Invoco il callback per salvare i fields to check della lookup
                      this.sendFieldsToCheckToParent(resourceLookup.ValueField_Name, this.fieldsToCheck)
                      
                    }
                    // Setto la resourceLookup
                    this.setState({lookupResource: resourceLookup})
                    // Se non ha LoadOnClick allora chiedo già i campi
                    if (!resourceLookup.LoadOnClick) {
                      this.reloadResourceLookupFields()
                    }
                    else {
                      // Ottengo la descrizione del primo Item
                      let filterString = '?RecordSelection=' + resourceLookup.ValueField_Name + " = '" + this.props.value + "'"
                      // Applico i filtri in caso ce ne siano
                      if (resourceLookup.ResourcesLookupsFilters && this.props.fatherObj) {
                        this.fieldsToCheck = []
                        for(var i=0;i< resourceLookup.ResourcesLookupsFilters.length;i++)
                        {
                            this.fieldsToCheck.push(resourceLookup.ResourcesLookupsFilters[i].ParentField_Name)
                            if (this.props.fatherObj[resourceLookup.ResourcesLookupsFilters[i].ParentField_Name]) {
                              filterString += " and "
                              + resourceLookup.ResourcesLookupsFilters[i].LookupField_Name 
                              + resourceLookup.ResourcesLookupsFilters[i].FilterOperator 
                              + "'" + this.props.fatherObj[resourceLookup.ResourcesLookupsFilters[i].ParentField_Name] + "'"
                            }
                            else this.filterFailed = true
                        }
                        if (this.filterFailed) filterString =  '?RecordSelection=1=0'
                      }

                      //var requrl ='api/Resources/' + resourceLookup.Resource_Name + filterString;
                      //if (this.props.isSys) requrl ='api/sys/' + resourceLookup.Resource_Name + filterString;
                      var requrl =resourceLookup.Resource_Endpoint + filterString;

                      // Vado a chiedere al servizio il primo item per recuperarne la descrizione completa
                      service
                        .getItems(requrl,t)
                        .then((elenco: any) =>  {
                            // Se trovo l'oggetto, allora setto la descrizione completa
                            if (elenco.length) {
                              var element=elenco[0];
                              if (element) {
                                var descriptionField:string="";
                                // Salvo i campi su cui poi filtrerò e intanto mi ricreo la descrizione completa
                                for(var idxFields=0;idxFields< resourceLookup.ResourcesLookupsDisplayFields.length;idxFields++)
                                {
                                  this.state.lookupResourceDisplayFilters.push(new EsaedroResourceFilter(resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name, '', ' like ', resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Description))
                                  descriptionField = descriptionField + (idxFields?" | ":"") + element[resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name];
                                }
                                // Mi salvo la descrizione completa a lookup non ancora caricata
                                this.initialDisplayField = descriptionField
                                this.setState({loading: false})
                              }
                              else {
                                // Salvo comunque i campi su cui poi filtrerò e intanto mi ricreo la descrizione completa
                                for(var idxFields=0;idxFields< resourceLookup.ResourcesLookupsDisplayFields.length;idxFields++)
                                {
                                  this.state.lookupResourceDisplayFilters.push(new EsaedroResourceFilter(resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name, '', ' like ', resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Description))
                                }
                                this.setState({loading: false})
                              } 
                            }
                            else {
                              // Salvo comunque i campi su cui poi filtrerò e intanto mi ricreo la descrizione completa
                              for(var idxFields=0;idxFields< resourceLookup.ResourcesLookupsDisplayFields.length;idxFields++)
                              {
                                this.state.lookupResourceDisplayFilters.push(new EsaedroResourceFilter(resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name, '', ' like ', resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Description))
                              }
                              this.setState({loading: false})
                            }
                        },
                        (error: any) => {this.setState({ loading: false, errorMessage: error });}); 
                    }
                }
                else this.setState({loading:false});
              } 
              else this.setState({loading:false});
          },
          (error: any) => {
              // Non ho trovato i dettagli della Resource Lookup
              this.setState({ loading: false, errorMessage: error });
          });
        
    }
    else
    {
      //Ultima spiaggia...valori items presi dal padre
      if (this.props.items!==undefined) this.setState({items:this.props.items, itemsToDisplay:this.props.items, loading: false});
      else this.setState({loading:false});
    }
  }

  sendFieldsToCheckToParent = (fieldName: string, fieldsToCheck: any[]) => {
    // Tramite callback manda alla ObjectEdit i campi da controllare per scatenare il re-rendering della lookup
    if (this.props.onFieldsToCheckLoaded != undefined)
      this.props.onFieldsToCheckLoaded(fieldName, fieldsToCheck)
  }

  reloadResourceLookupFields = () => {

    // Ricarica i campi della lookup
    this.setState({loading: true, toggleSearch: false})

    //Elenco da lookup resource
    if(this.state.lookupResource)
    {
      let resourceLookup = this.state.lookupResource

      let recSelString = '?RecordSelection='          
      let filterString = ""
      // Applico i filtri in caso ce ne siano
      if (resourceLookup.ResourcesLookupsFilters && this.props.fatherObj)
      {
        this.fieldsToCheck = []
        this.filterFailed = false
        for(var i=0;i< resourceLookup.ResourcesLookupsFilters.length;i++)
        {
            if (resourceLookup.ResourcesLookupsFilters[i].ParentField_Name) {
              this.fieldsToCheck.push(resourceLookup.ResourcesLookupsFilters[i].ParentField_Name)
              if (this.props.fatherObj[resourceLookup.ResourcesLookupsFilters[i].ParentField_Name]) {
                filterString += (i?" and ":"") 
                + resourceLookup.ResourcesLookupsFilters[i].LookupField_Name 
                + resourceLookup.ResourcesLookupsFilters[i].FilterOperator 
                + "'" + this.props.fatherObj[resourceLookup.ResourcesLookupsFilters[i].ParentField_Name] + "'"
              }
              else this.filterFailed = true
            }
            else if (resourceLookup.ResourcesLookupsFilters[i].FixedValue) {
              filterString += (i?" and ":"") 
                + resourceLookup.ResourcesLookupsFilters[i].LookupField_Name 
                + resourceLookup.ResourcesLookupsFilters[i].FilterOperator 
                + "'" + resourceLookup.ResourcesLookupsFilters[i].FixedValue + "'"
            }
        }
        if (this.filterFailed) filterString = '1=0'
      }

      // Applico anche i filtri eventuali impostati dalla maschera
      let filtersToAppend = ''
      if (this.state.lookupResourceDisplayFilters.length && !this.filterFailed) {

        if (filterString>'') filtersToAppend = " and "

        let found = false
        this.state.lookupResourceDisplayFilters.forEach(element => {
          if (element.Value!='') {
            filtersToAppend += (found?" and lower(":"lower(") 
            + element.FieldName
            + ')'
            + element.Operator
            + 'lower('
            + "'%" + element.Value + "%'"
            + ')'
            found = true
          }
        });

        if (!found) filtersToAppend = ''
      }

      const service = new cubeApiClient();
      const t = this.context.tokenAPI;

      // var requrl ='api/Resources/' + resourceLookup.Resource_Name + ((filterString>''||filtersToAppend>'')?recSelString + encodeURIComponent(filterString + filtersToAppend):'');

      // if (this.props.isSys) requrl ='api/sys/' + resourceLookup.Resource_Name + filterString + filtersToAppend;
      var requrl = resourceLookup.Resource_Endpoint + ((filterString>''||filtersToAppend>'')?recSelString + encodeURIComponent(filterString + filtersToAppend):'');

      service
        .getItems(requrl,t)
        .then((elenco: any) =>  {
          if (elenco) {
            let newItems: EsaedroLookupItem[] = []
            let newItemsToDisp: EsaedroLookupItem[] = []
            for (var i=0; i < elenco.length; i++) {
              var element=elenco[i];
              var descriptionField:string="";

              var hasFilterDisplayFields = this.state.lookupResourceDisplayFilters.length? true: false
              for(var idxFields=0;idxFields< resourceLookup.ResourcesLookupsDisplayFields.length;idxFields++)
              {
                if (!hasFilterDisplayFields) this.state.lookupResourceDisplayFilters.push(new EsaedroResourceFilter(resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name, '', ' like ', resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Description))
                descriptionField = descriptionField + (idxFields?" | ":"") + element[resourceLookup.ResourcesLookupsDisplayFields[idxFields].DisplayField_Name];
              }
              newItems.push(new EsaedroLookupItem(element[resourceLookup.ValueField_Name],descriptionField));
              newItemsToDisp.push(new EsaedroLookupItem(element[resourceLookup.ValueField_Name],descriptionField));                  
            }
            this.setState({
              items: newItems,
              itemsToDisplay: newItemsToDisp,
              loading:false
            });
          }
          else this.setState({loading:false})
        },
        (error: any) => {this.setState({ loading: false, errorMessage: error });}); 
    }
    else this.setState({loading:false});    

  }

  filterObjects = (e: any) => {

    let updateList = this.state.items;

    updateList = updateList.filter(item => {
    return item.description.toLowerCase().search(
        e.target.value.toLowerCase()
        ) !== -1;
    });

    this.setState({
        itemsToDisplay: updateList
    });
  }

  filterChange = (e: any) => {
    let newFilters = this.state.lookupResourceDisplayFilters
    newFilters.forEach(element => {
      if (element.FieldName == e.target.name) {
        element.Value = e.target.value.toString()
      }
    });
    this.setState({lookupResourceDisplayFilters: newFilters})
  }

  toggleSearchBtnPressed = () => {
    this.setState({toggleSearch: !this.state.toggleSearch})
  }
  
  render() {
    // Come prima cosa renderizzo oggetti che mi serviranno in caso di lookupResource
    let toggleButton = undefined
    let filterFields = undefined
    let lookupLabel = undefined
    let modalFilters = undefined

    if (this.state.lookupResource /*&& this.state.lookupResource.LoadOnClick*/) {
      toggleButton = <Button size="sm" onClick={this.toggleSearchBtnPressed} color="outline-info"><i className="fa fa-search"> </i></Button>
      filterFields = this.state.lookupResourceDisplayFilters.map((filter: EsaedroResourceFilter) => {
                          return (
                            <Row className={themeGroup()}>
                              <Col className={themeCol3()}>
                                <label htmlFor={filter.FieldName}>{filter.description}</label>   
                              </Col>
                              <Col className={themeCol9()}>
                                <input className={themeFormInput()} type="text" name={filter.FieldName}  value={filter.Value} onChange={this.filterChange}/>    
                              </Col>
                            </Row>
                          )
                        })
      lookupLabel = <label htmlFor={this.initialDisplayField}>{this.initialDisplayField}</label> 

      modalFilters =  <Modal isOpen={this.state.toggleSearch} toggle={this.toggleSearchBtnPressed}>
                        <ModalHeader toggle={this.toggleSearchBtnPressed}>Filtri Ricerca</ModalHeader>
                        <ModalBody>
                            {filterFields}      
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary" onClick={this.reloadResourceLookupFields}>Applica</Button>{' '}
                          <Button color="secondary" onClick={this.toggleSearchBtnPressed}>Annulla</Button>
                        </ModalFooter>
                      </Modal>
    }

    // Render in caso di loading
    if (this.state.loading)
    {
      return (
        <Row className={this.props.className?this.props.className:themeGroup()}>
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i> Caricamento...
          </Col>
        </Row>
      )
    }

    // Se non ci sono itemsToDisplay gestisco i vari casi
    else if (!this.state.itemsToDisplay.length) {

      // Non ci sono perchè mancano dei campi richiesti - Metto una combo vuota in ogni caso
      if (this.filterFailed) {
        return (
          <select className={this.props.className?this.props.className:themeGroup()}
                itemType="text" 
                name={this.props.name}
                value={this.props.value} 
                onChange={this.props.onChange}
                disabled={this.props.isDisabled}>
            <option value={''} >---- </option>
          </select>
        )
      }
      // Non ci sono perchè è una LoadOnClick - Metto il campo placeholder e renderizzo il tasto cerca
      else if (this.state.lookupResource && this.state.lookupResource.LoadOnClick){
        return (
          <Fragment>
            {toggleButton}
            {modalFilters}            
            {lookupLabel}
          </Fragment>
        )
      }
      // Altrimenti presumo che non siano arrivati dati
      else {
        return (
          <Row className={this.props.className?this.props.className:themeGroup()}>
            <Col className={themeCol9()}>
              Nessun dato disponibile...  
            </Col>
          </Row>
        )
      }
    }
    // Se invece ci sono items, renderizzo la lookup
    else
    {
      let emptyMessage = "Nessuna selezione..."
      /* Alternativa */
      //let emptyMessage = "Seleziona " + {this.props.displayName}
      
      const elements =(this.state.itemsToDisplay!==undefined? this.state.itemsToDisplay.map(        
        (item: EsaedroLookupItem) => { 
          const sele=(item.value === this.props.value?true:false);
          return <option value={item.value} selected={sele}>{item.description}</option>
        }
      ):'Non ci sono elementi da visualizzare...');

      if (this.state.lookupResource && this.state.lookupResource.LoadOnClick) {
        return (
          <Fragment>
            {modalFilters}  
            <ButtonGroup>
              {toggleButton}  
              <select className={this.props.className?this.props.className:themeGroup()}
                    itemType="text" 
                    name={this.props.name}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    disabled={this.props.isDisabled}>
                <option value={''} >{emptyMessage}</option>
                {elements}        
              </select>
            </ButtonGroup>
          </Fragment>
        )
      }
      else return (
        <Fragment>
          {modalFilters} 
          <ButtonGroup>
            {toggleButton}  
            <select className={this.props.className?this.props.className:themeGroup()}
                    itemType="text" 
                    name={this.props.name}
                    value={this.props.value} 
                    onChange={this.props.onChange}
                    disabled={this.props.isDisabled}>
              <option value={''} >{emptyMessage}</option>
              {elements}        
            </select>
          </ButtonGroup>
          
        </Fragment>
      )
    }
  }
}
